import { render } from "./Prenotazioni.vue?vue&type=template&id=d4f7e176"
import script from "./Prenotazioni.vue?vue&type=script&lang=js"
export * from "./Prenotazioni.vue?vue&type=script&lang=js"
script.render = render

export default script